import { useEffect } from 'react';
import confetti from 'canvas-confetti';

let hasFireworksPlayed = false;

const randomInRange = (min: number, max: number): number => Math.random() * (max - min) + min;

const fireFireworks = (): void => {
  const duration = 3000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 100, zIndex: 0, colors: ['#0090E3', '#FF6600'] };

  const interval = setInterval(() => {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      clearInterval(interval);
      return;
    }

    const particleCount = 50 * (timeLeft / duration);
    void confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
    void confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
  }, 400);
};

const EmailFireworks = (): null => {
  useEffect(() => {
    if (!hasFireworksPlayed) {
      hasFireworksPlayed = true;
      fireFireworks();
    }
  }, []);

  return null;
};

export default EmailFireworks;
